export enum Events {
    Sports = '1,2,4',
    Races = '7,4339',
    Casino = '99999,99995,99998,99992',
    Casino1 = '99999',
    ICasino = '99995',
    IntCasino = '99998',
    Binary = '99990',
    SportsBook = '99991',
    Others = '99990,99994,2378961',
}

export enum EventsName {
    ICasino = 'All Casino',
    Casino1 = 'CARDS'
}
